import { render } from "./f-submembers.vue?vue&type=template&id=1a832226&scoped=true"
import script from "./f-submembers.vue?vue&type=script&lang=js"
export * from "./f-submembers.vue?vue&type=script&lang=js"

import "./f-submembers.vue?vue&type=style&index=0&id=1a832226&lang=scss&scoped=true"

import exportComponent from "/builds/secur/secur-v2-cloud/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a832226"]])

export default __exports__